import '@/styles/globals.css';
import '@rimactechnology/rimac-ui-lib/dist/style.css';

import { ApolloProvider } from '@apollo/client';
import type { AppProps } from 'next/app';
import Head from 'next/head';

import { useApollo, useArticleApollo } from '@/api/apolloClient';
import { GoogleAnalytics } from '@/components/google/GoogleAnalytics';
import { Impressum } from '@/components/impressum/Impressum';

const App = ({ Component, pageProps }: AppProps) => {
  const client = useApollo(pageProps);
  const articleClient = useArticleApollo(pageProps);

  return (
    <ApolloProvider client={articleClient}>
      <ApolloProvider client={client}>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <title>Rimac Group</title>
        </Head>
        <GoogleAnalytics />
        <Component {...pageProps} />
        <Impressum key="impressum" />
      </ApolloProvider>
    </ApolloProvider>
  );
};

export default App;
